import Util from "@/helper/Utility.js";
/**
 * @exports RegistrationModel 
 * @exports RegistrationModelBulider 
*/
export function RegistrationModel() {
    this.cardNo = null;
    this.personalId = null;
    this.fullName = null;
    this.mobile = null;
    this.email = null;
    this.promotion = null;
    this.recruitmentCode = null;

    this.getParams = function () {
        let data = {
            cardno: this.cardNo,
            personalid: this.personalId,
            fullname: this.fullName,
            mobile: this.mobile,
            email: this.email,
            promotion: this.promotion,
            recruitmentCode: this.recruitmentCode,
        };
        return Util.cleanObjectEmptyStr(data);
    }
}
export function RegistrationModelBulider() {
    this.registrationModel = new RegistrationModel();

    this.create = () => {
        return this.registrationModel;
    }

    this.setCardNo = (cardNo) => {
        this.registrationModel.cardNo = cardNo;
        return this;
    }
    this.setPersonalId = (personalId) => {
        this.registrationModel.personalId = personalId;
        return this;
    }
    this.setFullName = (fullName) => {
        this.registrationModel.fullName = fullName;
        return this;
    }
    this.setMobile = (mobile) => {
        this.registrationModel.mobile = mobile;
        return this;
    }
    this.setEmail = (email) => {
        this.registrationModel.email = email;
        return this;
    }
    this.setPromotion = (promotion) => {
        this.registrationModel.promotion = promotion;
        return this;
    }
    this.setRecruitmentCode = (recruitmentCode) => {
        this.registrationModel.recruitmentCode = recruitmentCode;
        return this;
    }
}